module.exports = __webpack_public_path__ + "img/BAU_Partners_Infographics_17.59e20583.png";